import {  t  } from "@/client/libs/dummy-i18n";
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@stackmorph/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";

import { axios } from "@/client/libs/axios";

type DeleteOrgDialogProps = {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  organizationId: string;
  organizationName: string;
};

export const DeleteOrgDialog = ({ isOpen, setIsOpen, organizationId, organizationName }: DeleteOrgDialogProps) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutate: deleteOrg, isPending } = useMutation({
    mutationFn: async () => {
      await axios.delete(`/organization/${organizationId}`);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["organizations"] });
      void navigate("/dashboard/team");
    },
  });

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t`Delete Organization`}</DialogTitle>
          <DialogDescription>
            {t`Are you sure you want to delete`} <strong>{organizationName}</strong>? {t`This action cannot be undone.`}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button variant="ghost" onClick={() => { setIsOpen(false); }}>
            {t`Cancel`}
          </Button>
          <Button
            variant="error"
            disabled={isPending}
            onClick={() => {
              deleteOrg();
            }}
          >
            {t`Delete Organization`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
